import { ChangeEvent, FC } from "react";
import { Search } from "components-new";
import Switch from "components-new/Switch";
import { Button } from "components/shared";
import StepInfo from "pages/StepPages/components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "toolkit/hooks";
import cn from "classnames";
import styles from "../UserRoles.module.sass";

interface UserRolesHeaderProps {
	handleSwitch: (e: ChangeEvent<HTMLInputElement>) => void;
	handleQuery: (e: ChangeEvent<HTMLInputElement>) => void;
	query: string;
}

const UserRolesHeader: FC<UserRolesHeaderProps> = ({ handleSwitch, handleQuery, query }) => {
	const location = useLocation();

	const { admin } = useAppSelector((state) => state.users.currentUser);
	const amIAdmin = useAppSelector((state) => state.profile.profile.admin);

	const locationState = location.state;
	const userFullName = `${locationState.lastName} ${locationState.firstName} ${locationState.middleName}`;

	const { id } = useParams();

	const navigate = useNavigate();

	return (
		<div className="step-header">
			<StepInfo
				info="Роли пользователя"
				link={{
					to: `/user/${id}`,
					text: `${userFullName}`,
				}}
			/>

			<div className="step-header__actions">
				<Switch checked={admin} onChange={handleSwitch} className="step-header__actions-item">
					Администратор
				</Switch>
				<Search
					searchValue={query}
					handleSearch={handleQuery}
					placeholder="Найти организацию"
					className={cn(styles.search, "step-header__actions-item")}
				/>
				<Button className="step-header__actions-item" onClick={() => navigate("/settings/roles")} disabled={!amIAdmin}>
					Настроить роли
				</Button>
			</div>
		</div>
	);
};

export default UserRolesHeader;
